import { FC, ReactElement } from 'react';
import {
  Button as SharedButton,
  type ButtonProps as SharedButtonProps,
  type ButtonVariant,
  type ButtonSize,
  type ButtonIconPosition,
} from '@loomstateorg/shared-frontend';
import useButtonClassNames from 'helpers/hooks/useButtonClassNames';

export type { ButtonVariant, ButtonSize, ButtonIconPosition };
export type ButtonProps = Omit<SharedButtonProps, 'buttonClassName'>;

const Button: FC<ButtonProps> = ({
  icon,
  added,
  loading,
  children,
  className,
  disabled,
  asSkeleton = false,
  variant = 'primary',
  iconPosition = 'middle',
  size = children ? 's' : 'icon',
  ...props
}) => {
  const buttonClassName = useButtonClassNames({
    variant,
    size,
    className,
    includesIcon: !!icon && !!children,
    loading,
    asSkeleton,
  });

  return (
    <SharedButton
      icon={icon as ReactElement | undefined}
      added={added}
      loading={loading}
      disabled={disabled}
      asSkeleton={asSkeleton}
      variant={variant}
      iconPosition={iconPosition}
      size={size}
      buttonClassName={buttonClassName}
      {...props}
    >
      {children}
    </SharedButton>
  );
};

export default Button;
